import React from 'react';
import { Link } from 'react-router-dom';

export default function SiteMapPage() {
  const links = [
    { to: '/', label: 'Home' },
    { to: '/aboutus', label: 'About NRD' },
    { to: '/issnpage', label: 'ISSN' },
    { to: '/editorialboard', label: 'Editorial Board' },
    { to: '/currentissue', label: 'Current Issue' },
    { to: '/publications', label: 'Publications' },
    { to: '/login', label: 'Author Login' },
    { to: '/reviewlogin', label: 'Reviewer Login' },
    { to: '/adminlogin', label: 'Admin Login' },
    { to: '/register', label: 'Register' },
    { to: '/contact', label: 'Contact' },
    { to: '/userprofile', label: 'User Profile' },
    { to: '/manuscriptsteps', label: 'Manuscript Upload Steps' },
    { to: '/inboxmessages', label: 'Inbox Messages' },
    { to: '/messageuser', label: 'Send Message' },
    { to: '/assignauthorreview', label: 'Assign Author Review' },
    { to: '/reviewcheckedarticle', label: 'Review Checked Article' },
    { to: '/issuecertreview', label: 'Issue Certificate Review' },
    { to: '/admindashboard', label: 'Admin Dashboard' },
    { to: '/nrdarticlespublish', label: 'Publish Article' },
    { to: '/uploadarticleassign', label: 'Upload Article Assign' },
    { to: '/addarticleissue', label: 'Add New Volume Issue' },
  ];

  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h1 className="text-3xl font-bold mb-4">Site Map</h1>
      <ul className="list-disc list-inside space-y-2">
        {links.map(link => (
          <li key={link.to}>
            <Link to={link.to} className="text-blue-600 hover:underline">
              {link.label}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
